import { PlaceholderText } from 'components/Placeholders';

function OverviewMetricCell({
    value,
    label,
    labelLines = 2,
    valueTextSize = 'sm',
    uppercase = true,
    capitalize = false,
    hasBorder = true,
    tooltipWrapper,
    hoverColor,
    isLoading = false,
}) {
    const valueSizeClass =
        valueTextSize === 'base'
            ? 'text-base h-6'
            : valueTextSize === 'sm'
              ? 'text-sm h-5'
              : 'text-xs h-5';
    const valueClass = [
        valueSizeClass,
        'font-semibold truncate flex items-center transition-colors',
        uppercase && 'uppercase',
        capitalize && 'capitalize',
        hoverColor && 'group-hover/cell:text-[var(--metric-hover-color)]',
    ]
        .filter(Boolean)
        .join(' ');
    const cellClass = [
        'flex flex-col gap-1 px-3 py-2 min-w-0 overflow-hidden group/cell',
        hasBorder && 'border-r border-border',
    ]
        .filter(Boolean)
        .join(' ');
    const labelBase = 'text-xs text-muted-foreground';
    const labelWrap =
        labelLines === 2 ? 'line-clamp-2 min-h-[28px] text-pretty' : 'truncate';
    const labelInteractive = hoverColor
        ? 'transition-colors group-hover/cell:text-[var(--metric-hover-color)]'
        : '';
    const labelClass = [labelBase, labelWrap, labelInteractive]
        .filter(Boolean)
        .join(' ');
    const cellStyle = hoverColor
        ? { '--metric-hover-color': hoverColor }
        : undefined;
    const content = (
        <div className={cellClass} style={cellStyle}>
            <span className={valueClass}>
                {isLoading ? <PlaceholderText width="3rem" /> : value}
            </span>
            <span className={labelClass}>{label}</span>
        </div>
    );
    return !isLoading && tooltipWrapper ? tooltipWrapper(content) : content;
}

export default OverviewMetricCell;
